/*#__PURE__*/ export default {"key":"skeleton","type":"root","items":[{"key":"enabled","def":true,"type":"bool"}]};